// extracted by mini-css-extract-plugin
export default {"comment":"CommentInput_comment__fBrLh","button":"CommentInput_button__e4NJB"};